import React, { Component } from "react";
import GeneralChar from "../components/CharacteristicSelector";
import { Grid } from "@material-ui/core";

// import GENERO_MASCULINO from "./../../../../images/icons/characteristics/gender/f-masculino.svg";
// import GENERO_FEMENINO from "./../../../../images/icons/characteristics/gender/f-femenino.svg";

// import GE_0_13 from "./../../../../images/icons/characteristics/edge/f-0-13.svg";
// import GE_14_17 from "./../../../../images/icons/characteristics/edge/f-14-17.svg";
// import GE_18_27 from "./../../../../images/icons/characteristics/edge/f-18-27.svg";
// import GE_28_59 from "./../../../../images/icons/characteristics/edge/f-28-59.svg";
// import GE_60MAS from "./../../../../images/icons/characteristics/edge/f-60+.svg";

// import JORNADA_MADRUGADA from "./../../../../images/icons/characteristics/time/f-madrugada.svg";
// import JORNADA_MAÑANA from "./../../../../images/icons/characteristics/time/f-manana.svg";
// import JORNADA_TARDE from "./../../../../images/icons/characteristics/time/f-tarde.svg";
// import JORNADA_NOCHE from "./../../../../images/icons/characteristics/time/f-noche.svg";

// import ARMA_BLANCA from "./../../../../images/icons/characteristics/firegun-kind/f-arma-b.svg";
// import ARMA_FUEGO from "./../../../../images/icons/characteristics/firegun-kind/f-arma-f.svg";
// import ARMA_CONTUNDENTE from "./../../../../images/icons/characteristics/firegun-kind/f-contundente.svg";
// import ARMA_EXPLOSIVO from "./../../../../images/icons/characteristics/firegun-kind/f-explosivo.svg";
// import ARMA_MINA_ANTIPERSONA from "./../../../../images/icons/characteristics/firegun-kind/f-mina.svg";
// import ARMA_AHORCAMIENTO from "./../../../../images/icons/characteristics/firegun-kind/f-ahorcamiento.svg";
// import ARMA_BOLSA_PLASTICA from "./../../../../images/icons/characteristics/firegun-kind/f-bolsa.svg";
// import ARMA_PUNZANTE from "./../../../../images/icons/characteristics/firegun-kind/f-punzante.svg";
// import ARMA_PAQUETE_BOMBA from "./../../../../images/icons/characteristics/firegun-kind/f-bomba.svg";

// import ZONA_URBANA from "./../../../../images/icons/characteristics/zone/f-urbano.svg";
// import ZONA_RURAL from "./../../../../images/icons/characteristics/zone/f-rural.svg";

// import NO_REPORTA from "./../../../../images/icons/miscellaneus/f-no-aplica.svg";
// import OTRO from "./../../../../images/icons/miscellaneus/f-otro.svg";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "./../../../../Actions/Dashboard";

const Genero = [
  { icon: null, value: "Masculino", group: "genero", id: 1 },
  { icon: null, value: "Femenino", group: "genero", id: 2 },
];

const GrupoEtario = [
  { icon: null, value: "MENORES", group: "grupo_etareo", id: 1 },
  { icon: null, value: "ADOLESCENTES", group: "grupo_etareo", id: 2 },
  { icon: null, value: "ADULTOS", group: "grupo_etareo", id: 3 },
];

class ContCharacteristics extends Component {
  handleContCh = (value, id, group) => {
    const type = group.split("_");
    this.props.actions.selectFilter({ id, value }, type[type.length - 1]);
  };

  render() {
    return (
      <Grid>
        <Grid>
          <GeneralChar
            data={Genero}
            onContCh={(value, id, group) => this.handleContCh(value, id, group)}
            title="Género"
          />
        </Grid>
        <Grid>
          <GeneralChar
            data={GrupoEtario}
            onContCh={(value, id, group) => this.handleContCh(value, id, group)}
            title="Grupo Etario"
          />
        </Grid>
      </Grid>
    );
  }
}

function mapDispathToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(null, mapDispathToProps)(ContCharacteristics);
